import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { BpayPaymentDetailsOption } from 'apps/legacy/src/app/_shared/models';
import { Observable } from 'rxjs';
import { IContributionPaymentBreakdownComponentState } from '../contribution-payment-breakdown/contribution-payment-breakdown.component';

@Component({
  selector: 'vpa-bpay-payment',
  templateUrl: './bpay-payment.component.html',
  styleUrls: ['./bpay-payment.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BpayPaymentComponent implements OnInit {
  @Input() paymentDetailsOption: BpayPaymentDetailsOption;
  @Input() contributionPaymentBreakdown$: Observable<IContributionPaymentBreakdownComponentState>;

  constructor() {}

  ngOnInit(): void {}
}
